import React from "react";

/* Downward chevron for disclosure controls. `open` rotates it 180°, so a
   caller can pass its expanded state straight through. */
export const ChevronDown = ({ size = 14, open = false, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden="true"
    focusable="false"
    className={`transition-transform ${open ? "rotate-180" : ""} ${className}`}
  >
    <path
      d="M4 6l4 4 4-4"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ChevronDown;
